import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatCardModule } from '@angular/material/card';
import { ControlRoomService } from 'app/services/control-room.service';
import { TranslateModule } from '@ngx-translate/core';
import { AngularMaterialModules } from "app/angular-material-modules";
import { PickUpActivationName } from 'app/pipes/pipes';
import moment from 'moment';
import { CrAlert } from 'app/services/crsync.service';


@Component({
    selector: 'app-incoming-alert-card',
    templateUrl: './incoming-alert-card.component.html',
    styleUrls: ['./incoming-alert-card.component.css'],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [CommonModule, MatCardModule, CdkDragHandle, TranslateModule, AngularMaterialModules, PickUpActivationName]
})
export class IncomingAlertCardComponent {

  @Input() alert: CrAlert;
  @Input() isNightowlVisit: boolean = false;
  @Input() disabled: boolean = false;

  constructor(
    public crService: ControlRoomService,
  ) { }

  calculateRemainingTime(data: any) {
    if (!this.isNightowlVisit) {
        const timeRemaining = moment(data.end).diff(moment(), 'seconds');
        return timeRemaining;
      };
  
      const endTime = moment(data.cameraVisitStartTime).add(data.cameraVisitDurationMinutes, 'minutes');
      const timeLeft = endTime.diff(new Date(), 'seconds');
      return timeLeft;
  }

}
